import { render, staticRenderFns } from "./StatusAlert.vue?vue&type=template&id=56271f8e"
import script from "./StatusAlert.vue?vue&type=script&lang=js"
export * from "./StatusAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports